import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import AdminAccessRole from '../../modules/admin/components/AdminAccessRole';

const AccessRole = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('admin->>AdminAccessRole.Admin Access Configuration')} />

      <ContentTemplate type="full">
        <AdminAccessRole />
      </ContentTemplate>
    </>
  );
};

export default AccessRole;
